import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { AuthLayout, AuthField } from "@/components/AuthLayout";
import { useAuth } from "@/lib/auth";
import { useT } from "@/lib/i18n";

const ForgotPasswordPage = () => {
  const t = useT();
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await forgotPassword(email); } catch {}
    setLoading(false);
    setSent(true);
  };

  return (
    <AuthLayout
      testId="page-forgot"
      title={t("auth.reset_title")}
      subtitle={t("auth.reset_sub")}
      footer={<><Link to="/login" className="text-[color:var(--gv-pink)]">{t("cta.back_to_login")}</Link></>}
    >
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-success">
          <CheckCircle2 size={36} className="mx-auto text-[color:var(--gv-pink)] mb-4" />
          <div className="font-display text-[20px] text-[color:var(--gv-ink)] mb-2">{t("auth.check_inbox")}</div>
          <div className="text-[13.5px] text-[color:var(--gv-ink)]/65">{t("auth.check_inbox_text", { email })}</div>
        </div>
      ) : (
        <form onSubmit={onSubmit}>
          <AuthField label={t("auth.email")}>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="gv-input" placeholder="you@email.com" data-testid="forgot-email" />
          </AuthField>
          <button disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">{loading ? t("common.loading") : <>{t("cta.send_link")} <ArrowRight size={16} /></>}</button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
